export default [
    {
        path: '/preferences',
        name: 'preferences',
        component: () => import('@/views/preferences/show'),
        meta: { permission: ['access_preferences'], pageTitle: 'preferences', breadcrumb: [{text: 'preferences'}]}
    },
   
]
